import { useTranslation } from '@cobliteam/i18n';
import Typography from '@cobliteam/ui/components/Typography';
import Icon from '@cobliteam/ui/icons';

interface DriverFaceIdHeaderProps {
  filesCount?: number;
  filesMax?: number;
}

const DriverFaceIdHeader = ({ filesMax, filesCount = 0 }: DriverFaceIdHeaderProps) => {
  const { t } = useTranslation('drivers');

  return (
    <div className='flex items-center gap-4'>
      <Icon name='scan-face' size='sm' />
      <Typography variant='text-md-semibold'>
        {filesMax ? t('face_id.drawer.review.registered_photos_with_max', { filesCount, filesMax }) : t('face_id.drawer.review.registered_photos')}
      </Typography>
    </div>
  );
};

export default DriverFaceIdHeader;
